import {
  SHOP_FIND_OR_CREATE_FAILURE,
  SHOP_SETTINGS_FIND_FAILURE,
  BARCODE_TEMPLATE_CREATE_FAILURE,
  BARCODE_TEMPLATE_DELETE_FAILURE,
  BARCODE_TEMPLATE_INDEX_FAILURE,
  BARCODE_TEMPLATE_UPDATE_FAILURE,
  BARCODE_TEMPLATE_PREVIEW_FAILURE,
  SEARCH_PRODUCT_SKU_FAILURE,
  REPLACE_PRODUCT_SKU_FAILURE,
  DELETE_PRODUCT_SKU_FAILURE,
  DOWNLOAD_PREVIEW_REQUESTED,
  DOWNLOAD_PREVIEW_SUCCESS,
  DOWNLOAD_PREVIEW_FAILURE,
  SEARCH_PRODUCT_FAILURE,
  PRINT_CREATE_FAILURE,
  ADD_INVENTORY_FAILURE,
  SUBTRACT_INVENTORY_FAILURE,
  SET_INVENTORY_FAILURE,
  SCAN_INVENTORY_FAILURE,
  BULK_INVENTORY_CHANGE_FAILURE,
  BATCH_DETAILS_FAILURE,
  BATCH_INVENTORY_RESULTS_FAILURE,
  BATCH_INVENTORY_RESULT_ROW_FAILURE,
  BATCH_INVENTORY_DOWNLOAD_FAILURE,
  GET_FUNGIBLES_FAILURE,
  GET_LINE_SETTINGS_FAILURE,
  CATEGORIES_FAILURE,
  PUBLISH_ORDER_FAILURE,
  READ_ORDER_FAILURE,
  SETTINGS_FAILURE,
  SETTINGS_UPDATE_FAILURE,
  LOGO_UPLOAD_FAILURE,
  BARCODE_TEMPLATES_UPGRADE_FAILURE,
  CREATE_BARCODES_FAILURE,
  CREATE_ALL_BARCODE_IMAGES_FAILURE,
  CREATE_ALL_BARCODE_VALUES_FAILURE,
  REFRESH_BATCHES_FAILURE,
  DOWNLOAD_BARCODE_IMAGE_FAILURE,
  SEARCH_PRODUCT_BARCODE_VALUE_FAILURE,
  TRANSFER_INVENTORY_FAILURE,
  LOCATIONS_INDEX_FAILURE,
  CREATE_FULFILLMENT_FAILURE,
  SHOPIFY_SETTINGS_FIND_FAILURE,
  FIND_BARCODE_IMAGE_FAILURE,
} from '../types';

const INITIAL_STATE = {
  requiresRefresh: false,
};

const activeToken = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case SHOP_FIND_OR_CREATE_FAILURE:
    case SHOP_SETTINGS_FIND_FAILURE:
    case BARCODE_TEMPLATE_CREATE_FAILURE:
    case BARCODE_TEMPLATE_DELETE_FAILURE:
    case BARCODE_TEMPLATE_INDEX_FAILURE:
    case BARCODE_TEMPLATE_UPDATE_FAILURE:
    case BARCODE_TEMPLATE_PREVIEW_FAILURE:
    case SEARCH_PRODUCT_SKU_FAILURE:
    case REPLACE_PRODUCT_SKU_FAILURE:
    case DELETE_PRODUCT_SKU_FAILURE:
    case DOWNLOAD_PREVIEW_REQUESTED:
    case DOWNLOAD_PREVIEW_SUCCESS:
    case DOWNLOAD_PREVIEW_FAILURE:
    case SEARCH_PRODUCT_FAILURE:
    case PRINT_CREATE_FAILURE:
    case ADD_INVENTORY_FAILURE:
    case SUBTRACT_INVENTORY_FAILURE:
    case SET_INVENTORY_FAILURE:
    case SCAN_INVENTORY_FAILURE:
    case BULK_INVENTORY_CHANGE_FAILURE:
    case BATCH_DETAILS_FAILURE:
    case BATCH_INVENTORY_RESULTS_FAILURE:
    case BATCH_INVENTORY_RESULT_ROW_FAILURE:
    case BATCH_INVENTORY_DOWNLOAD_FAILURE:
    case GET_FUNGIBLES_FAILURE:
    case GET_LINE_SETTINGS_FAILURE:
    case CATEGORIES_FAILURE:
    case PUBLISH_ORDER_FAILURE:
    case READ_ORDER_FAILURE:
    case SETTINGS_FAILURE:
    case SETTINGS_UPDATE_FAILURE:
    case LOGO_UPLOAD_FAILURE:
    case BARCODE_TEMPLATES_UPGRADE_FAILURE:
    case CREATE_BARCODES_FAILURE:
    case CREATE_ALL_BARCODE_IMAGES_FAILURE:
    case CREATE_ALL_BARCODE_VALUES_FAILURE:
    case REFRESH_BATCHES_FAILURE:
    case DOWNLOAD_BARCODE_IMAGE_FAILURE:
    case SEARCH_PRODUCT_BARCODE_VALUE_FAILURE:
    case TRANSFER_INVENTORY_FAILURE:
    case LOCATIONS_INDEX_FAILURE:
    case CREATE_FULFILLMENT_FAILURE:
    case SHOPIFY_SETTINGS_FIND_FAILURE:
    case FIND_BARCODE_IMAGE_FAILURE:
      if(action.status === 401 || action.status === 403) {
        newState.requiresRefresh = true;
      }
      return newState;

    default:
      return state;
  }
}

export default activeToken;
